var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import * as _ from 'lodash';
import * as moment from 'moment-timezone';
import { UserCategory } from './user-service';
export var JudgeState;
(function (JudgeState) {
    JudgeState[JudgeState["pending"] = 0] = "pending";
    JudgeState[JudgeState["judging"] = 1] = "judging";
    JudgeState[JudgeState["done"] = 2] = "done";
})(JudgeState || (JudgeState = {}));
export class ChallengeFilter {
    constructor() {
        this.user_uid = null;
        this.problem_uid = null;
        this.result = null;
        this.category = null;
    }
    load(data) {
        let obj = JSON.parse(data);
        this.user_uid = obj['user_uid'];
        this.problem_uid = obj['problem_uid'];
        this.result = obj['result'];
        this.category = obj['category'];
    }
    serialize() {
        if (this.user_uid === '') {
            this.user_uid = null;
        }
        if (this.problem_uid === '') {
            this.problem_uid = null;
        }
        return JSON.stringify(this);
    }
}
export function emit(path, data = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        let result = yield axios.post('/api' + path, data);
        return result.data;
    });
}
export function getProfile(user_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/user/${user_uid}/profile`, {});
    });
}
export function getUserStatistic(user_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/user/${user_uid}/statistic`, {});
    });
}
export function listUser() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit('/user/list', {});
    });
}
export function setUser(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/user/${data.uid}/set`, data);
    });
}
export function removeUser(user_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/user/${user_uid}/remove`, {});
    });
}
export function listProSet() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit('/proset/list', {});
    });
}
export function createProSet(name) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit('/proset/create', {
            name: name,
        });
    });
}
export function getProSet(proset_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/proset/${proset_uid}/get`, {});
    });
}
export function setProSet(proset) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/proset/${proset.uid}/set`, proset);
    });
}
export function removeProSet(proset_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/proset/${proset_uid}/remove`, {});
    });
}
export function addProItem(proset_uid, problem) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/proset/${proset_uid}/add`, {
            problem_uid: problem.uid,
        });
    });
}
export function getProItem(proset_uid, proitem_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        let proitem = yield emit(`/proset/${proset_uid}/${proitem_uid}/get`, {});
        if (proitem !== 'Error') {
            if (proitem.deadline !== null) {
                let date = moment(proitem.deadline, moment.ISO_8601).tz(moment.tz.guess());
                proitem.deadline = date.format('YYYY/MM/DD HH:mm:ss');
            }
        }
        return proitem;
    });
}
export function setProItem(proset_uid, proitem) {
    return __awaiter(this, void 0, void 0, function* () {
        let modified_proitem = _.cloneDeep(proitem);
        if (proitem.deadline === '') {
            modified_proitem.deadline = null;
        }
        else if (proitem.deadline !== null) {
            modified_proitem.deadline = proitem.deadline + '+0800';
        }
        return yield emit(`/proset/${proset_uid}/${proitem.uid}/set`, modified_proitem);
    });
}
export function removeProItem(proset_uid, proitem_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/proset/${proset_uid}/${proitem_uid}/remove`, {});
    });
}
export function listProItem(proset_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        let proitems = yield emit(`/proset/${proset_uid}/list`, {});
        if (proitems !== 'Error') {
            for (let proitem of proitems) {
                if (proitem.deadline !== null) {
                    let date = moment(proitem.deadline, moment.ISO_8601).tz(moment.tz.guess());
                    proitem.deadline = date.format('YYYY/MM/DD HH:mm:ss');
                }
            }
        }
        return proitems;
    });
}
export function listProSumScore(proset_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        let prosumscores = yield emit(`/proset/${proset_uid}/listscore`, {});
        return prosumscores;
    });
}
export function updateProblem(problem_uid, git_url) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/problem/${problem_uid}/update`, { git_url });
    });
}
export function removeProblem(problem_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/problem/${problem_uid}/remove`, {});
    });
}
export function listProblem() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/problem/list`, {});
    });
}
export function getProblem(problem_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/problem/${problem_uid}/get`, {});
    });
}
export function getProblemRate(problem_uid, category) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/problem/${problem_uid}/rate`, { category });
    });
}
export function submit(problem_uid, code, lang) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/problem/${problem_uid}/submit`, { code, lang });
    });
}
export function rejudgeProblem(problem_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/challenge/rejudge`, { problem_uid });
    });
}
export function rejudgeSingleChallenge(challenge_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/challenge/rejudgechal`, { challenge_uid, async_judge: true });
    });
}
export function getChallenge(challenge_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        let challenge = yield emit(`/challenge/${challenge_uid}/get`, {});
        if (challenge !== 'Error') {
            let date = moment(challenge.timestamp, moment.ISO_8601).tz(moment.tz.guess());
            challenge.timestamp = date.format('YYYY/MM/DD HH:mm:ss');
        }
        return challenge;
    });
}
export function listChallenge(offset, filter = null) {
    return __awaiter(this, void 0, void 0, function* () {
        let partial_list = yield emit(`/challenge/list`, { offset, filter });
        if (partial_list !== 'Error') {
            for (let challenge of partial_list.data) {
                if (challenge !== null) {
                    let date = moment(challenge.timestamp, moment.ISO_8601).tz(moment.tz.guess());
                    challenge.timestamp = date.format('YYYY/MM/DD HH:mm:ss');
                }
            }
        }
        return partial_list;
    });
}
export function listChallengeTemp(offset, filter = null, chal_uid_base = null) {
    return __awaiter(this, void 0, void 0, function* () {
        let partial_list = yield emit(`/challenge/list`, { offset, filter, reverse: true, chal_uid_base });
        if (partial_list !== 'Error') {
            for (let challenge of partial_list.data) {
                if (challenge !== null) {
                    let date = moment(challenge.timestamp, moment.ISO_8601).tz(moment.tz.guess());
                    challenge.timestamp = date.format('YYYY/MM/DD HH:mm:ss');
                }
            }
        }
        return partial_list;
    });
}
export function refreshRank() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/rank/refresh`, {});
    });
}
export function getRank(proset_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/rank/${proset_uid}/list`, {});
    });
}
export function getRankWithScore(proset_uid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield emit(`/rank/-${proset_uid}/list`, {});
    });
}
export function getCategory(category) {
    switch (category) {
        case UserCategory.universe: return 'Universe';
        case UserCategory.algo: return 'Algo';
        case UserCategory.clang: return 'CLang';
        case UserCategory.pylang: return 'PyLang';
    }
}
export function getResult(state, result, abbreviation = false) {
    if (abbreviation) {
        switch (state) {
            case JudgeState.pending: return 'PD';
            case JudgeState.judging: return 'JD';
            case JudgeState.done:
                switch (result) {
                    case 1: return 'AC';
                    case 2: return 'WA';
                    case 3: return 'RE';
                    case 4: return 'TLE';
                    case 5: return 'MLE';
                    case 6: return 'CE';
                    default: return 'OTH';
                }
            default: return 'UNK';
        }
    }
    else {
        switch (state) {
            case JudgeState.pending: return 'Pending';
            case JudgeState.judging: return 'Judging';
            case JudgeState.done:
                switch (result) {
                    case 1: return 'Accepted';
                    case 2: return 'Wrong Answer';
                    case 3: return 'Runtime Error';
                    case 4: return 'Time Limit Exceeded';
                    case 5: return 'Memory Limit Exceeded';
                    case 6: return 'Compile Error';
                    default: return 'Other';
                }
            default: return 'Unknown';
        }
    }
}



// WEBPACK FOOTER //
// ./src/api.ts